export default __webpack_public_path__ + "static/media/raw-past.43407397.jpg";